import React from 'react';

type Props = {
  contactText?: string
}

export default function ContactLink(props: Props) {
  const contactText = props.contactText || 'Contact';
  return <a href='https://faq.hellosign.com/hc/en-us/requests/new'>{contactText}</a>;
}
